import React from 'react';

import CopyToClipboard from './CopyToClipboard';
import FacebookSVG from '../svg/icons/facebook.svg';
import LinkedInSVG from '../svg/icons/linkedin.svg';
import TwitterSVG from '../svg/icons/twitter.svg';

const linkedin = (link = '', message = '') =>
  `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
    link
  )}&title=${encodeURIComponent(message)}&summary=${encodeURIComponent(
    message
  )}&source=${encodeURIComponent(link)}`;
const twitter = (link = '', message = '') =>
  `https://twitter.com/intent/tweet/?text=${encodeURIComponent(
    message
  )}&url=${encodeURIComponent(link)}`;

const facebook = (link = '') =>
  `https://facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`;

const ShareSheet = ({ title, url }) => {
  return (
    <div className="inline-flex items-center">
      <a href={facebook(url)} className="p-3 hover:text-cornflower">
        <FacebookSVG className="w-5 h-5" />
      </a>

      <a href={twitter(url, title)} className="p-3 hover:text-cornflower">
        <TwitterSVG className="w-5 h-5" />
      </a>

      <a href={linkedin(url, title)} className="p-3 hover:text-cornflower">
        <LinkedInSVG className="w-5 h-5" />
      </a>

      <CopyToClipboard
        value={url}
        className="p-3 text-zodiac hover:text-cornflower"
      />
    </div>
  );
};

export default ShareSheet;
